import { Injectable } from '@angular/core';
//import { Zoom } from '@ionic-native/zoom/ngx';
import { Platform } from '@ionic/angular';


declare const JitsiMeetPlugin: any;
declare const JitsiMeet: any;
//import { InAppBrowser,InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';

@Injectable()
export class VideoCallService {
    /*options : InAppBrowserOptions = {
        location : 'no', //Or  'yes'
        hidden : 'no', //Or  'yes'
        zoom : 'yes',//Android only ,shows browser zoom controls
        hideurlbar:'yes',//Or 'no'

    };*/
    constructor(/*private iab: InAppBrowserprivate zoomService: Zoom,*/ private platform: Platform) { }

    /*   openBrowser(url){
           let target = "_blank";
           const browser = this.iab.create(url, target, this.options);
       }*/

    startVideoCall(meetingid, pswd, username) {
        let id;
        if (this.platform.is('ios')) {
            id = meetingid.split(" ").join('');
        } else {
            id = meetingid;
        }

        let options = {
            "no_driving_mode": true,
            "no_invite": true,
            "no_meeting_end_message": true,
            "no_titlebar": false,
            "no_bottom_toolbar": false,
            "no_dial_in_via_phone": true,
            "no_dial_out_to_phone": true,
            "no_disconnect_audio": true,
            "no_share": true,
            "no_audio": false,
            "no_video": false,
            "no_meeting_error_message": true
        };
        //   this.zoomService.joinMeeting(id, pswd , username, options)
        // .then((success: any) => console.log(success))
        // .catch((error: any) => console.log(error));
    }




    joinJitsiMeeting(meetingURL, joineeName, joineeImage, endtime) {
        let index = meetingURL.lastIndexOf("/");

        const endTimeString = endtime;
        const endTimeArray = endTimeString.split(":").map(Number);

        const endTime = new Date();
        endTime.setHours(endTimeArray[0], endTimeArray[1], endTimeArray[2]);

        console.log(endTime); // Assuming date3 is the end time in a timestamp format

        const checkEndTimeInterval = setInterval(() => {
            const currentTime = new Date().getTime();
            const endTimestamp = endTime.getTime();
            // console.log("currentTime",currentTime)
            // console.log("endTimestamp",endTimestamp)
            if (currentTime >= endTimestamp) {
                // End the meeting
                clearInterval(checkEndTimeInterval);
                this.endJitsiMeeting();
            }
        }, 1000);

        JitsiMeet.startConference(
            {
                serverURL: meetingURL,
                room: meetingURL.substring(index),//meetingURL.substring(index),
                displayName: joineeName,
                defaultLocalDisplayName: "TOM",
                defaultRemoteDisplayName: "TOM",
                DEFAULT_LOCAL_DISPLAY_NAME: "TOM",
                DEFAULT_REMOTE_DISPLAY_NAME: "TOM",
                hideDisplayName: true,
                BRAND_WATERMARK_LINK: 'https://alpha.theonemoment.com/usr/share/jitsi-meet/images/watermark.svg',

    CLOSE_PAGE_GUEST_HINT: false, // A html text to be shown to guests on the close page, false disables it

    DEFAULT_BACKGROUND: '#474747',
//    DEFAULT_LOGO_URL: 'images/watermark.svg',
//    DEFAULT_WELCOME_PAGE_LOGO_URL: 'images/watermark.svg',
      DEFAULT_LOGO_URL: 'https://alpha.theonemoment.com/usr/share/jitsi-meet/images/watermark.svg',
      DEFAULT_WELCOME_PAGE_LOGO_URL: 'https://alpha.theonemoment.com/usr/share/jitsi-meet/images/watermark.svg',
                email: "max@amazingmax.it",
                audioMuted: false,
                videoMuted: false,
                welcomePageEnabled: false,
                subject: "My amazing name",
                audioOnly: false,
                //token: "your jwt token, if you have one",
                flags: {
                    "chat.enabled": true,
                    "invite.enabled": false,
                    "kick-out.enabled": false,
                    "prejoinpage.hideDisplayName": true,
                    "live-streaming.enabled": false,
                    "pip.enabled": true,
                    "raise-hand.enabled": false,
                    "recording.enabled": true,
                    "video-share.enabled": false,
                    "add-people.enabled": false,
                    "calendar.enabled": true,
                    "meeting-name.enabled": false,
                    "meeting-password.enabled": true,
                    "toolbox.alwaysVisible": true,
                    "ios.recording.enabled": true,
                    "ios.screensharing.enabled": true
                }
            }, function (listener) {
                // a listener has been fired!
                console.log(listener);

                switch (listener) {
                    case "CONFERENCE_JOINED":
                        //Broadcasted when a conference was joined.
                        break;
                    case "CONFERENCE_TERMINATED":
                        //Broadcasted when the active conference ends, be it because of user choice or because of a failure.
                        break;
                    case "CONFERENCE_WILL_JOIN":
                        //Broadcasted before a conference is joined.
                        break;
                    case "AUDIO_MUTED_CHANGED":
                        //Broadcasted when audioMuted state changed
                        break;
                    case "VIDEO_MUTED_CHANGED":
                        //Broadcasted when videoMuted state changed
                        break;
                    case "PARTICIPANT_JOINED":
                        //Broadcasted when a participant has joined the conference.
                        break;
                    case "PARTICIPANT_LEFT":
                        //Broadcasted when a participant has joined the conference.
                        break;
                    case "ENDPOINT_TEXT_MESSAGE_RECEIVED":
                        //Broadcasted when an endpoint text message is received.
                        break;
                    case "PARTICIPANTS_INFO_RETRIEVED":
                        //Broadcasted when a RETRIEVE_PARTICIPANTS_INFO action is called.
                        break;
                    case "CHAT_MESSAGE_RECEIVED":
                        //Broadcasted when a chat text message is received.
                        break;
                    case "CHAT_TOGGLED":
                        //Broadcasted when the chat dialog is opened or closed.
                        break;
                }
            });

    }


    endJitsiMeeting() {
        // Logic to end the Jitsi meeting
        console.log('Ending Jitsi meeting');
        console.log("Meeting has ended. Triggering endConference.");
        JitsiMeet.endConference(); // End the conference when the time is up
        // You can add any necessary cleanup or additional logic here
    }



}
